import React, { useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import styled from 'styled-components';
import cm from 'helpers/commons';
import toastr from 'helpers/toastr';
import * as usageAction from 'actions/usage';

import { Modal as Confirm } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Modal, Form } from 'semantic-ui-react';
import { TableForm } from 'components/Commons';

const FormWrapper = styled.div`
  .ui.form .inline.field {
    & > label {
      width: 100px;
      color: #000;
    }
    .ui.input input {
      padding: 10px;
    }
  }
`;
const TableWrapper = styled.div`
  position: relative;
  overflow-y: scroll;
  min-width: 100%;
  min-height: 86px;
  max-height: 200px;
  border: 1px solid #dcdcdc;

  .tb-common.ui.table {
    border: none;

    thead {
      z-index: 1;
      position: fixed;
      width: calc(100% - 48px);

      & > tr > th.center.aligned {
        width: 129px; // calc(100% / 3);
        height: 40px;
        padding: 0px;
      }
    }
    tbody {
      position: relative;
      top: 42px;
    }
  }
`;
const defaultColumns = [
  { header: '수정일', name: 'regDate', textAlign: 'center', width: 150 },
  { header: '바코드 정보', name: 'changeLog', textAlign: 'center', width: 150 },
  { header: '수정자', name: 'userName', textAlign: 'center', width: 90 }
];
const generateColumns = (values) => {
  const thead = defaultColumns.map((item) => ({ data: item.header, ...item }));
  const tbody = values.map((item) => {
    const row = defaultColumns.map((column) => {
      const value =
        column.name === 'regDate' ? moment(item[column.name]).format('YYYY-MM-DD HH:mm:ss') : item[column.name];
      return { data: value || '-', ...column };
    });
    return { row };
  });
  return {
    header: { main: thead },
    body: { main: values.length ? tbody : undefined, message: '수정 내역이 존재하지 않습니다' }
  };
};

const BarcodeDetailModal = ({ open, user, onClose, onSuccess, usageAPI, barcodeHistories }) => {
  const [barcode, setBarcode] = useState(null);

  useEffect(() => {
    if (open && user && user.userInfo && user.barCodeInfo) {
      usageAPI.getBarcodeHistories(user.barCodeInfo.barCodeIdx);
      setBarcode(user.barCodeInfo.barCode);
    } else {
      setBarcode(null);
    }
  }, [user, open]);

  const setBarcodeInfo = async () => {
    try {
      const hasBarcode = user && user.barCodeInfo ? user.barCodeInfo.barCode : false;
      const barCodeStaticIdx = hasBarcode ? user.barCodeInfo.barCodeIdx : undefined;
      const barCodeNumber = hasBarcode ? barcode : undefined;

      await usageAPI.updateBarcode({ barCodeUserInfo: user.userInfo, barCodeStaticIdx, barCode: barCodeNumber });
      await toastr('top-right', 'success', '사원증 결제정보 수정이 완료되었습니다.');
      onClose();
      onSuccess();
    } catch (error) {
      if (error && error.response && error.response.data) {
        const { message } = error.response.data;
        toastr('top-right', 'error', message);
      }
    }
  };

  const handleSubmit = async () => {
    if (user && user.userInfo) {
      Confirm.confirm({
        title: '사원증 결제정보 수정',
        content: '사원증 결제정보를 수정하시겠습니까?',
        icon: null,
        okText: '확인',
        cancelText: '취소',
        // style: { top: '50%', transform: 'translateY(-50%)' },
        onOk: setBarcodeInfo
      });
    }
  };

  const tableData = useMemo(() => {
    const { barCodeHistoryResponse } = barcodeHistories || {};
    return generateColumns(barCodeHistoryResponse || []);
  }, [barcodeHistories]);

  return (
    <Modal open={open} onClose={onClose} style={{ width: 450 }}>
      <Modal.Header style={{ justifyContent: 'space-between', padding: '12px 20px' }}>
        <div>사원증 결제정보 수정</div>
      </Modal.Header>
      <Modal.Content>
        <FormWrapper>
          <Form>
            <Form.Field inline label="아이디" control={() => <span>{user.userInfo.signId || '-'}</span>} />
            <Form.Field inline label="이름" control={() => <span>{user.userInfo.name || '-'}</span>} />
            <Form.Field inline label="사원" control={() => <span>{user.userInfo.employeeId || '-'}</span>} />
            <Form.Field
              inline
              label="부서"
              control={() => {
                const division = cm.trTdDivision(user.userInfo.orgCode);
                return (
                  <span style={{ display: 'inline-grid' }}>
                    {division.map((item) => (
                      <span style={{ width: '250px' }}>{item}</span>
                    ))}
                  </span>
                );
              }}
            />
            <Form.Input
              inline
              required
              label="바코드 정보"
              value={barcode}
              onChange={(value) => setBarcode(value.target.value)}
            />
          </Form>
        </FormWrapper>

        <div
          style={{
            fontSize: '16px',
            fontWeight: 700,
            color: '#000',
            padding: '24px 0px 16px',
            borderBottom: '1px solid #dcdcdc',
            marginBottom: '16px'
          }}
        >
          바코드 수정 기록
        </div>
        <TableWrapper className="table-box">
          <TableForm selectable="true" tabledata={tableData} columnWidth={[150, 142, 96]} />
        </TableWrapper>
      </Modal.Content>
      <Modal.Actions style={{ padding: '12px 20px' }}>
        <Button content="취소" style={{ width: '70px', padding: '10px 20px 9px' }} onClick={onClose} />
        <Button
          color="green"
          content="저장"
          style={{ width: '70px', padding: '10px 20px 9px' }}
          onClick={handleSubmit}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default connect(
  (state) => ({
    barcodeHistories: (state.usage.barcodeHistories || {}).data
  }),
  (dispatch) => ({
    usageAPI: bindActionCreators(
      {
        getBarcodeHistories: usageAction.getBarcodeHistories,
        createBarcode: usageAction.createBarcode,
        updateBarcode: usageAction.updateBarcode
      },
      dispatch
    )
  })
)(BarcodeDetailModal);
